import { styled } from "styled-components";
import { Modal as AntdModal, Button } from "antd";
import {
  IProduct,
  IProductType,
  ISubscription,
  increaseUsage,
  openNotification,
} from "@dataone/lib";
import IncreaseModal from "./IncreaseModal";
import PaymentModal from "./PaymentModal";
import { useState } from "react";
import { useMutation } from "@tanstack/react-query";

interface ModalProps {
  children?: React.ReactNode;
  isOpen: boolean;
  close: () => void;
  subscription: ISubscription;
  productsData: IProduct[];
  isSearchIncrease: boolean;
  isPromptChartUpdate: boolean;
  setShowPayment: (value: boolean) => void;
  showPayment: boolean;
}
export interface ProductData {
  searchMinValue: number;
  searchMaxValue: number;
  searchUnitAmount: number;
  searchPrice: number;
  chatMinValue: number;
  chatMaxValue: number;
  chatUnitAmount: number;
  chatPrice: number;
  promptChartUpdateMinValue: number;
  promptChartUpdateMaxValue: number;
  promptChartUpdateUnitAmount: number;
  promptChartUpdatePrice: number;
  quantity: number;
}
const Modal = ({
  isOpen,
  close,
  subscription,
  productsData,
  isSearchIncrease,
  setShowPayment,
  showPayment,
  isPromptChartUpdate,
}: ModalProps) => {
  const { mutate: increase, isLoading: increaseUsageLoading } = useMutation({
    mutationFn: increaseUsage,
  });
  const [searchData, setSearchData] = useState<ProductData>();
  const [onSuccess, setOnSuccess] = useState<boolean>(false);
  const [cardId, setCardId] = useState<string>("");
  const handleIncreaseUsage = async () => {
    increase(
      {
        Type: isSearchIncrease
          ? IProductType.SEARCH
          : isPromptChartUpdate
          ? IProductType.PROMPT_CHART_UPDATE
          : IProductType.CHAT,
        quantity: searchData?.quantity || 0,
        cardId: cardId,
      },
      {
        onSuccess: () => {
          setOnSuccess(true);
        },
        // onError: () => {
        //   openNotification("Something went wrong, please try again later");
        // },
      }
    );
  };

  return (
    <StyledIncreaseModal>
      <StyledModal
        getContainer="#profile-modal"
        destroyOnClose
        open={isOpen}
        width={"100%"}
        onCancel={close}
        styles={{
          mask: {
            position: "absolute",
            borderRadius: "20px 40px 40px 40px",
          },
        }}
        wrapClassName="absolute-modal-wrap"
        footer={[
          <Button className="cancle-btn" onClick={close}>
            Cancel
          </Button>,
          showPayment && (
            <Button
              className="confirm-payment-btn"
              onClick={() => {
                handleIncreaseUsage();
                close();
                setCardId("");
                setOnSuccess(false);
              }}
            >
              Confirm
            </Button>
          ),
        ]}
      >
        {!showPayment ? (
          <IncreaseModal
            isSearchIncrease={isSearchIncrease}
            isPromptChartUpdate={isPromptChartUpdate}
            subscription={subscription}
            productsData={productsData}
            setShowPayment={setShowPayment}
            setSearchData={setSearchData}
            searchData={searchData!}
          />
        ) : (
          <PaymentModal
            isSearchIncrease={isSearchIncrease}
            isPromptChartUpdate={isPromptChartUpdate}
            searchData={searchData!}
            setCardId={setCardId}
            onSuccess={onSuccess}
          />
        )}
      </StyledModal>
    </StyledIncreaseModal>
  );
};

export default Modal;

const StyledModal = styled(AntdModal)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .ant-modal-content {
    min-width: 300px;
    // width: 80vw;
    width: 65vw;
    padding: 22px 30px;
    // height: 86vh;
    min-height: 492px;
  }
  .ant-modal-body {
    height: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .ant-modal-footer {
    display: flex;
    // gap: 20px;
    justify-content: flex-end;
  }
  .ant-modal-close-x .anticon svg {
    margin-right: 25px;
    margin-top: 16px;
  }
  span.anticon.anticon-close.ant-modal-close-icon {
    background-color: white;
    margin-top: -6px;
  }
  .cancle-btn {
    height: 38px;
    background-color: #eff1fd;
    color: #000;
    border: none;
    border-radius: 10px;
    font-size: 12px;
    width: 100px;
    &:hover {
      color: #000 !important;
      border: none;
    }
  }
  .confirm-payment-btn {
    height: 38px;
    background-color: #4974f6;
    color: #fff;
    border: none;
    border-radius: 10px;
    font-size: 12px;
    width: 100px;
    &:hover {
      color: #fff !important;
      border: none;
    }
  }
`;
const StyledIncreaseModal = styled.div``;
